import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        // window.scrollTo(0, 0) alone is a no-op on this site: App.css's
        // `html, body { overflow-x: hidden }` triggers the CSS spec's
        // overflow-x/y "computed value" correction (setting only one axis
        // to non-visible forces the other to `auto`), so BOTH html and body
        // end up with an implicit overflow-y:auto. Combined with their
        // `height: 100%` rule, body becomes its own independently-scrolling
        // box instead of just deferring to the document/viewport scroll —
        // so the element the user actually scrolls (body) is never the one
        // window.scrollTo touches (document.scrollingElement, which stays
        // documentElement/html in standards mode and never has any
        // overflow of its own here). Reset all three so this keeps working
        // even if that CSS setup changes later. `behavior: 'auto'`
        // overrides the global `scroll-behavior: smooth !important` so
        // navigating feels instant, not an animated scroll-up.
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    }, [pathname]);

    return null;
}